export default __webpack_public_path__ + "static/media/7.0016b4a9.png";